import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64 } from '../../../../../../app.constants';
import { IrFracaoPatrimonialObeterAnosModel } from '../../../../models/ir-fracao-patrimonial-obter-anos.model';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { MesPipe } from '../../../../pipe/mes.pipe';
import { FormateNumberZeroPipe } from '../../../../pipe/format-number-zero.pipe';

@Injectable()
export class IrPatrimonialPdf {

  constructor(
    private _decimalPipe: DecimalPipe,
    private _formateNumberZeroPipe: FormateNumberZeroPipe,
    private _cpf: CpfPipe,
    private _mesPipe: MesPipe
  ) { }

  public funcionarios(pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel, vlFracaoTotal: number,
    vlIrrfTotal: number, irFracaoPatrimonialObterAnosModel: Array<IrFracaoPatrimonialObeterAnosModel>, processoFormatadoTela: string) {

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(IMAGEM_LOGO_CENTRUS_BASE64, 'PNG', 90, 20, 30, 20);
    doc.setFontSize(13);
    doc.setFont('Source Sans Pro');
    doc.setFontStyle('bold');
    doc.text(`CONSULTA IR DA FRAÇÃO PATRIMONIAL SUB JUDICE`, 40, 50)

    doc.autoTable({
      startY: 60
    })

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      head: [['CPF', 'Nome']],
      body: [[this._cpf.transform(pessoaDadosSimplicadosModel.cpf), pessoaDadosSimplicadosModel.nome]],
    });


    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9,
      },
      head: [[`Processo Nro.: ${processoFormatadoTela}`]],
    });

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      head: this._headRows(),
      body: this._bodyRows(irFracaoPatrimonialObterAnosModel),
      foot: [[
        `Total`,
        `${this._decimalPipe.transform(vlFracaoTotal)}`,
        `${this._decimalPipe.transform(vlIrrfTotal)}`, ]]
    });


    doc.setFontSize(10);
    doc.setFont('Source Sans Pro');
    doc.text(`Valores nominais (sem correção) e sujeitos a alteração.`, 60, doc.previousAutoTable.finalY + 10)


    doc.setProperties({
      title: 'Ir Fração Patrimonial',
      subject: `IR da Fração Patrimonial Sub Judice `,
      author: 'centrus',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'Fundação Banco central de previcência provida - centrus'
    });

    (window.innerWidth > 640)
      ? (window.open(URL.createObjectURL(doc.output('blob'))))
      : this.handleFile(doc.output('blob'), 'irfpsj.pdf');
  }

  handleFile(res: any, fileName: string) {
    const file = new Blob([res], {
      type: res.type
    });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }



    const blob = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;

    // link.click();
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    setTimeout(() => { // firefox
      window.URL.revokeObjectURL(blob);
      link.remove();
    }, 100);
  }


  private _bodyRows(irFracaoPatrimonialObterAnosModel: Array<IrFracaoPatrimonialObeterAnosModel>) {
    const body = []

    irFracaoPatrimonialObterAnosModel.map(item => {
      body.push({
        aaReferencia: this._mesPipe.transform(item.aaReferencia),
        vlFracao: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlFracao, '1.1-2')),
        vlIrrf: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlIrrf, '1.1-2'))
      })
    })
    return body;
  }


  private _headRows() {
    return [{
      aaReferencia: 'Ano',
      vlFracao: 'Fração',
      vlIrrf: 'IRRF'
    },
    ]
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/financeiro/ir-patrimonial/ir-patrimonial-pdf.ts